/**
 * Shared currency utility functions
 * 
 * These functions are used by both util/currencies.jsx and hooks/useCurrencies.jsx
 * to avoid code duplication and ensure consistency.
 */

import constants from '@/constants'

/**
 * Parse currency decimal places based on ratio
 */
export const parseCurrencyDecimalPlaces = (decimalPlaces, ratio) => {
  return ratio === 1 ? decimalPlaces : decimalPlaces - Math.abs(Math.log10(ratio))
}

/**
 * Check if a currency is real money (not OOM)
 */
export const isRealMoney = (currencyId, oomsCurrencyId = 'OOM') => {
  return currencyId && currencyId !== oomsCurrencyId
}

/**
 * Get currency parameter based on whether it's real money
 */
export const getCurrencyParameter = (isRealMoney) => {
  return isRealMoney ? constants.CANONICAL_CURRENCY : 'OOM'
}

/**
 * Parse currency parameter from currency ID
 */
export const parseCurrencyParameter = (currencyId, oomsCurrencyId = 'OOM') => {
  return getCurrencyParameter(isRealMoney(currencyId, oomsCurrencyId))
}

/**
 * Get market type based on whether it's real money
 */
export const getMarketType = (isRealMoney) => {
  return isRealMoney ? constants.REAL_MONEY : constants.PLAY_MONEY
}

/**
 * Get currency mode from currency ID
 */
export const getCurrencyMode = (currencyId, oomsCurrencyId = 'OOM') => {
  return getMarketType(isRealMoney(currencyId, oomsCurrencyId))
}

/**
 * Convert from canonical currency (BTC) to display currency
 */
export const convertFromCanonical = (valueInBtc, exchangeRate) => {
  return valueInBtc * exchangeRate
}

/**
 * Convert to canonical currency (BTC) from display currency
 */
export const convertToCanonical = (valueInCurrency, exchangeRate) => {
  return valueInCurrency / exchangeRate
}

